import React, { FC } from 'react';
import Stack from '@mui/material/Stack';

import {
  TimesheetFooter,
  TimesheetGrid,
  TimesheetHeader,
  TimesheetProviders,
  TimesheetSummary,
} from 'src/features/timesheets';
import { useTranslate } from 'src/shared/providers';

export const TimesheetsPage: FC = () => {
  const { t } = useTranslate();

  return (
    <div id="page-wrapper">
      <Stack gap={2}>
        <h2>{t('timesheets.timesheet')}</h2>
        <TimesheetProviders>
          <TimesheetHeader />
          <TimesheetGrid />
          <TimesheetFooter />
          <TimesheetSummary />
        </TimesheetProviders>
      </Stack>
    </div>
  );
};
